'use client';

import {
  useCallback,
  useState,
  type ChangeEvent,
  type FocusEvent,
} from 'react';
import {
  applyDeploymentDelayInputChange,
  blockDeploymentDelayNonIntegerKeys,
  formatDeploymentDelayDraft,
  isDeploymentDelayDraftSubmittable,
  normalizeDeploymentDelayDraft,
  parseDeploymentDelayDraft,
} from './deployment-delay-input';

export const useDeploymentDelayDraft = ({
  currentDelayHours,
  isReadOnly = false,
}: {
  currentDelayHours: number | undefined;
  isReadOnly?: boolean;
}) => {
  const [draftDelay, setDraftDelay] = useState('');

  const resetDraftFromCurrent = useCallback(() => {
    setDraftDelay(formatDeploymentDelayDraft(currentDelayHours));
  }, [currentDelayHours]);

  const handleDelayChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setDraftDelay(applyDeploymentDelayInputChange(event.target.value.trim()));
    },
    [],
  );

  const handleDelayBlur = useCallback((event: FocusEvent<HTMLInputElement>) => {
    setDraftDelay(normalizeDeploymentDelayDraft(event.target.value.trim()));
  }, []);

  const parsedDraftHours = parseDeploymentDelayDraft(draftDelay);
  const isSubmitDisabled =
    isReadOnly ||
    !isDeploymentDelayDraftSubmittable(draftDelay) ||
    parsedDraftHours === currentDelayHours;

  return {
    draftDelay,
    parsedDraftHours,
    resetDraftFromCurrent,
    handleDelayChange,
    handleDelayBlur,
    handleDelayIntegerKeyDown: blockDeploymentDelayNonIntegerKeys,
    isSubmitDisabled,
  };
};
